import { TextWrapper } from "./styles";

interface CardProps {
  children: React.ReactNode;
  variant: "title" | "subtitle"
}

export default function Text ({children, ...props}: CardProps) {
  return <TextWrapper {...props}>{children}</TextWrapper>
}